/** Type of repository */
export var PlaceRepositoryType;
(function (PlaceRepositoryType) {
    /** Repository is a collection of Driver logic */
    PlaceRepositoryType["Driver"] = "driver";
    /** Repository is a collection of interfaces */
    PlaceRepositoryType["Interface"] = "interface";
})(PlaceRepositoryType || (PlaceRepositoryType = {}));
